import {
  faKey,
  faPencil,
  faTimes,
  faUserPlus,
  faUserSlash,
  faWarning,
  faWrench,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DataTable } from "@ventumsoftware/react-toolkit";
import React, { type FC, useMemo } from "react";
import { useNavigate } from "react-router";
import { useApi } from "../../api/APIContext";
import { ContentContainer } from "../../components/content/ContentContainer";
import { PageHeader } from "../../components/content/PageHeader";
import { Badge, BadgeStyle } from "../../components/data/Badge";
import { TablePlaceholder } from "../../components/data/TablePlaceholder";
import { Button, IconButton } from "../../components/form/Button";
import { Loading } from "../../components/Loading";
import { useModal } from "../../components/layout/ModalProvider";
import { Paragraph } from "../../components/Paragraph";
import { AddUserModal } from "../../modals/AddUserModal";

export const SettingsUsersPage: FC<{}> = (props) => {
  const { users, loading, refresh } = useApi();
  const navigate = useNavigate();
  const addUserModal = useModal({
    title: "Gebruiker toevoegen",
    body: <AddUserModal />,
    size: "md",
  });
  const sortedUsers = useMemo(() => {
    return users.sort((a, b) => {
      if (a.enabled && !b.enabled) {
        return -1;
      }
      if (!a.enabled && b.enabled) {
        return 1;
      }
      if (a.isAdmin && !b.isAdmin) {
        return -1;
      }
      if (!a.isAdmin && b.isAdmin) {
        return 1;
      }
      if (a.isApiUser && !b.isApiUser) {
        return -1;
      }
      if (!a.isApiUser && b.isApiUser) {
        return 1;
      }
      return a.last_name.localeCompare(b.last_name);
    });
  }, [users]);
  return (
    <ContentContainer size={"lg"}>
      <div className={"flex items-center justify-between"}>
        <PageHeader>Gebruikersbeheer</PageHeader>
        <div>
          <Button
            type={"primary"}
            size={"md"}
            text={"Gebruiker toevoegen"}
            onClick={() => addUserModal.open()}
          />
        </div>
      </div>
      <div className={"-mt-2 max-w-(--breakpoint-lg)"}>
        <Paragraph>
          Toegang tot de tablet-app en/of de web-applicatie is gedeeltelijk of volledig te
          realiseren met gebruikersbeheer. Op basis van rechten op een bedrijf en/of sub-bedrijven
          krijgt de gebruiker de relevante rechten.
        </Paragraph>
      </div>
      <Loading loading={loading}>
        {sortedUsers.length === 0 ? (
          <TablePlaceholder>Geen gebruikers in systeem</TablePlaceholder>
        ) : (
          <DataTable
            keyProperty={"id"}
            compact={true}
            data={sortedUsers}
            pageSize={50}
            onClickRow={(row) => {
              navigate(`/settings/users/${row.id}`);
            }}
            columns={[
              {
                header: "Naam",
                sort: true,
                property: "last_name",
                transform: (value, row) => (
                  <div>
                    <div>
                      {row.first_name} {row.last_name}
                    </div>
                    <div className={"text-slate-600 text-xs"}>
                      {row.email} &middot; {row.username}
                    </div>
                  </div>
                ),
              },
              {
                header: "Toegang",
                property: "role",
                transform: (value, row) => {
                  if (!row.enabled) {
                    return (
                      <Badge style={BadgeStyle.warning}>
                        <FontAwesomeIcon icon={faWarning} className={"mr-1"} /> Inloggen
                        uitgeschakeld
                      </Badge>
                    );
                  }
                  if (row.isAdmin) {
                    return (
                      <Badge style={BadgeStyle.success}>
                        <FontAwesomeIcon icon={faWrench} className={"mr-1"} /> Administrator
                      </Badge>
                    );
                  }
                  if (row.isApiUser) {
                    return (
                      <Badge style={BadgeStyle.info}>
                        <FontAwesomeIcon icon={faKey} className={"mr-1"} /> Systeem Koppeling
                      </Badge>
                    );
                  }
                },
              },
            ]}
          />
        )}
      </Loading>
    </ContentContainer>
  );
};
